var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.427,
    height: 20.014,
    viewBox: "0 0 16.427 20.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20514",
    "data-name": "Path 20514",
    d: "M162.14,39.375a2.45,2.45,0,0,0-2.455,2.455V56.935a2.45,2.45,0,0,0,2.455,2.455h11.518a2.45,2.45,0,0,0,2.455-2.455V41.83a2.45,2.45,0,0,0-2.455-2.455Zm0,1.133h11.518a1.314,1.314,0,0,1,1.322,1.322V56.935a1.314,1.314,0,0,1-1.322,1.322H162.14a1.314,1.314,0,0,1-1.322-1.322V41.83A1.314,1.314,0,0,1,162.14,40.508Zm.755,3.272a.566.566,0,0,0,0,1.133h9.629a.566.566,0,1,0,0-1.133Zm0,2.832a.566.566,0,0,0,0,1.133h9.629a.566.566,0,1,0,0-1.133Zm0,2.832a.566.566,0,0,0,0,1.133h5a.566.566,0,1,0,0-1.133Z",
    transform: "translate(-159.685 -39.375)",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.2c5d2eda580db663ddf529e9990d5219.svg";
export { ForwardRef as ReactComponent };